import { RouteLocationNormalizedLoaded } from 'vue-router';
import { createStore, useStore as baseUseStore } from 'vuex';

import apigateway, { ApigatewayState } from './modules/apigateway';
import bottomDrawer, { BottomDrawerState } from './modules/bottomDrawer';
import brandKit from './modules/brandKit';
import platformBrandKit from './modules/brandKit/platformBrandKit';
import { PlatformBrandKitState } from './modules/brandKit/platformBrandKit/types';
import { BrandKitState } from './modules/brandKit/types';
import { default as event } from './modules/event';
import { EventState } from './modules/event/types';
import eventsource, { EventSourceState } from './modules/eventsource';
import { default as filterBar, FilterBarState } from './modules/filterBar';
import liveVideoRoom, { LiveVideoRoomState } from './modules/liveVideoRoom';
import mattermost, { MattermostState } from './modules/mattermost';
import mediaroom from './modules/mediaroom';
import { MediaRoomState } from './modules/mediaroom/types';
import notifications, { NotificationState } from './modules/notifications';
import session from './modules/session';
import sidebar, { SidebarState } from './modules/sidebar';
import simuliveroom, { SimuliveVideoRoomState } from './modules/simuliveroom';
import timeSync from './modules/timeSync';
import { TimeSyncState } from './modules/timeSync/types';
import { default as user } from './modules/user';
import { UserState } from './modules/user/types';

import { setStore, storeKey } from '@/utils/storeAccess';

const modules: { event: any } = {
  notifications,
  mattermost,
  eventsource,
  apigateway,
  event,
  user,
  filterBar,
  sidebar,
  bottomDrawer,
  liveVideoRoom,
  mediaroom,
  simuliveroom,
  session,
  timeSync,
  brandKit,
  platformBrandKit
} as any;

export type RootState = UserState & {
  swRegistration: ServiceWorkerRegistration | null;
  mattermost: MattermostState;
  eventsource: EventSourceState;
  notifications: NotificationState;
  session: any;
  user: UserState;
  event: EventState;
  route: RouteLocationNormalizedLoaded;
  apigateway: ApigatewayState;
  filterBar: FilterBarState;
  sidebar: SidebarState;
  bottomDrawer: BottomDrawerState;
  liveVideoRoom: LiveVideoRoomState;
  mediaroom: MediaRoomState;
  i18n: any;
  simuliveroom: SimuliveVideoRoomState;
  timeSync: TimeSyncState;
  brandKit: BrandKitState;
  platformBrandKit: PlatformBrandKitState;
};

const store = createStore<RootState>({
  modules,
  state: {
    swRegistration: null
  } as any,
  getters: {
    swRegistration(state) {
      return state.swRegistration;
    }
  },
  actions: {
    reset({ dispatch }) {
      // resets state of all the modules
      Object.keys(modules).forEach(moduleName => {
        if (moduleName !== 'user') {
          dispatch(`${moduleName}/RESET`);
        } else {
          dispatch('RESET');
        }
      });
    },
    getServiceWorkerRegistration(context) {
      return navigator.serviceWorker.ready.then(function (swRegistration) {
        context.state.swRegistration = swRegistration;
      });
    }
  },
  strict: false
});

setStore(store);

// removed during scalability changes as its not clear what this helps with
/*
store.subscribe(
  debounce(() => {
    // save state in local storage
    saveState({
      session: store.state.session,
      currentUser: store.state.user.currentUser
    });
  }, 1000)
);
*/

// define your own `useStore` composition function
export function useStore() {
  return baseUseStore(storeKey);
}

export default store;
